import React, { useState } from 'react';
import { useQuery, useMutation } from 'react-query';
import { endpoints, fetcher } from 'services';
import { message } from 'antd';
import { MSG } from 'commons/constants';

const useProjectOperator = (group_srl: number) => {
  /* ======================================================
   * state
   * ====================================================== */
  const [dailyInfo, setDailyInfo] = useState<OperatorDailyItemDto>();
  const [operatorInfo, setOperatorInfo] = useState<OperatorItemDto[]>([]);
  const [scheculeInfo, setScheculeInfo] = useState<OperatorScheculeItemDto[]>([]);


  /* ======================================================
   * hooks
   * ====================================================== */
  const { refetch, isSuccess } = useQuery(
    [endpoints.project.operator.info, group_srl],
    () =>
      fetcher.project.postProjectOperatorInfo({id: group_srl}),
    {
      enabled: group_srl > 0,
      onSuccess: (res: ProjectOperatorInfoResDto) => {
        switch (res.code) {
          case 200:
            setDailyInfo(res.result?.info.daily);
            setOperatorInfo(res.result?.info.operator || []);
            setScheculeInfo(res.result?.info.schedule || []);
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );

  const { mutate: operatorUpdate, isSuccess: isUpdated } = useMutation(
    [endpoints.project.operator.save],
    fetcher.project.postProjectOperatorSave,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            break;
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )  
  
  const { mutate: operatorDelete, isSuccess: isDeleted } = useMutation(
    [endpoints.project.operator.delete],
    fetcher.project.postProjectOperatorDelete,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            break;
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )   

  return { isSuccess, refetch, dailyInfo, operatorInfo, scheculeInfo, operatorUpdate, operatorDelete, isUpdated, isDeleted };
};

export default useProjectOperator;
